import React, { useState } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Typography,
} from '@material-ui/core'
import { removeRepresentationMipyme } from '../../../../../services/Representacion/create'
import Swal from 'sweetalert2'
import { useAuthentication } from '../../../../../context/authenticationContext'

export const ModalRemoveRepresentationMipyme = ({
  open,
  setOpen,
  rowData,
  getInProcessForms,
}) => {
  const [body, setBody] = useState({
    Observation: '',
  })

  const { userIDB2C } = useAuthentication()
  const handleClose = () => {
    setOpen(false)
    setBody({
      Observation: '',
    })
  }

  const handleGuardar = async () => {
    const values = {
      idMIPYME: rowData.IdMiPyme,
      Observation: body.Observation,
      idUserB2C: userIDB2C,
    }

    const response = await removeRepresentationMipyme(values)
    if (response.Success) {
      Swal.fire({
        title: '¡Mipyme removida exitosamente!',
        icon: 'success',
      })

      handleClose()
      setOpen(false)
      getInProcessForms()
    } else {
      Swal.fire({
        title: 'Ocurrio un Error al remover la Mipyme...' + response.Message,
        icon: 'error',
      })
      getInProcessForms()
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <Grid className="modalTitle">
            <Typography
              id="modal-modal-title"
              style={{ fontWeight: '900' }}
              variant="h6"
              component="h2"
            >
              ELIMINAR REPRESENTACIÓN
            </Typography>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid
              container
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
              }}
            >
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Motivos para dejar de representar a la MIPYME:
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <textarea
                          id="Observation"
                          name="Observation"
                          placeholder="Motivos para dejar de representar a la MIPYME:"
                          customInput={TextField}
                          inputProps={{ maxLength: 250 }}
                          onChange={(e) => {
                            setBody({
                              ...body,
                              Observation: e.target.value,
                            })
                          }}
                          value={body.Observation}
                        ></textarea>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button className="confirmButton" onClick={handleGuardar}>
                  Eliminar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
